import React from "react";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogFooter,
  AlertDialogTitle, AlertDialogDescription, AlertDialogCancel, AlertDialogAction,
} from "@/components/ui/alert-dialog";

// Single confirmation dialog reused for every delete / archive action.
export function ConfirmDialog({
  open, onOpenChange, title, description, confirmLabel = "Confirm",
  destructive = true, onConfirm, testid = "confirm-dialog",
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="bg-nb-surface rounded-2xl" data-testid={testid}>
        <AlertDialogHeader>
          <AlertDialogTitle className="text-nb-ink font-display">{title}</AlertDialogTitle>
          {description && <AlertDialogDescription className="text-nb-ink2">{description}</AlertDialogDescription>}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-cancel" className="rounded-[10px]">Cancel</AlertDialogCancel>
          <AlertDialogAction
            data-testid="confirm-accept"
            onClick={onConfirm}
            className="rounded-[10px] font-semibold"
            style={destructive
              ? { background: "var(--neg-text)", color: "#ffffff" }
              : { background: "var(--brand-navy)", color: "var(--text-inverse)" }}
          >
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
